var _path, _path2, _circle, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFileImage = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M14 2v5a1 1 0 0 0 1 1h5"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 12,
  r: 2
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "m20 17-1.296-1.296a2.41 2.41 0 0 0-3.408 0L9 22"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgFileImage);
export { ForwardRef as ReactComponent };